// import CourseApi from '../../../api/src/basic/api/CourseApi'
import {message} from "ant-design-vue";

// const courseApi = new CourseApi();

const state = {
    courseList: []
}

const mutations = {
    addClazzCourseList(state, data) {
        state.courseList = data || []
    },
}

const actions = {
    // 获取全部课程列表
    initClazzCourse: async ({commit, state}) => {
        let res = await courseApi.list();
        res.map((item, key) => item.key = key)
        commit('addClazzCourseList', res)
        return res
    },
    // 分页课程列表
    pageCourse: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            courseApi.page(query.pageNum, query.companyId, query.gradationId).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 添加课程
    addCourse: ({commit, state}, query) => {
        return new Promise((resolve, reject) => {
            courseApi.add(query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                reject()
            })
        })
    },
    // 删除课程
    delCourse: ({commit, state}, id) => {
        return new Promise((resolve, reject) => {
            courseApi.remove(id).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                reject(err)
                console.log(err)
            })
        })
    },
    // 修改课程
    editCourse: ({commit, state}, query) => {
        console.log(query)
        return new Promise((resolve, reject) => {
            courseApi.update(query.id, query.body).then(res => {
                resolve(res)
            }).catch(err => {
                message.error(err.message)
                console.log(err)
            })
        })
    },

}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}